<template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="ma-0 pa-0">
            <v-card v-for="(item, index) in cpRecord" :key="index" flat class="mt-1">
              <v-card-title class="subtitle-1 font-weight-bold justify-center">{{item.checkpilot}}</v-card-title>
              <div class="text-center mx-auto">
                <div style="display: inline-block; text-align: left;">
                  <v-card-text>

                    <div v-if="item.capid != null"><label><span class="font-weight-bold">CAPID: </span>{{item.capid}}</label><br /></div>
                    <div v-if="item.currentstatus != null"><label><span class="font-weight-bold">Status: </span>{{item.currentstatus}}</label><br /></div>
                    <div v-if="item.expirationdate != null"><label><span class="font-weight-bold">Expiration Date: </span>{{item.expirationdate}}</label><br /></div>
                    <br />
                    <div v-if="item.email != null"><label><span class="font-weight-bold">Email: </span>{{item.email}}</label><br /></div>
                    <div v-if="item.unitname != null"><label><span class="font-weight-bold">Unit: </span>{{item.unitname}}</label><br /></div>
                    <div v-if="item.city != null"><label><span class="font-weight-bold">Location: </span>{{item.city + ', ' + item.state}}</label><br /></div>
                    <div v-if="item.homephone != 'N/A'">
                      <span  class="font-weight-bold">Home Phone: </span>
                      <label> {{item.homephone.slice(0,3) + '-' + item.homephone.slice(3, 6) + '-' + item.homephone.slice(6)}}</label>
                    </div>
                    <div v-if="item.cellphone != 'N/A'">
                      <span class="font-weight-bold">Cell Phone: </span>
                      <label> {{item.cellphone.slice(0,3) + '-' + item.cellphone.slice(3, 6) + '-' + item.cellphone.slice(6)}}</label>
                    </div>
                    <br />

                    <div v-if="item.quallist != null"><label><span class="font-weight-bold">Other Qualifications: </span>{{item.quallist}}</label><br /><br /></div>
                    <div class="text-center">
                        <v-btn v-if="item.homephone != 'N/A'" class="mx-2" fab dark small color="blue darken-4" :href="`tel:+1${item.homephone}`">
                          <v-icon dark>mdi-phone</v-icon>
                        </v-btn>
                        <v-btn v-if="item.cellphone != 'N/A'" class="mx-2" fab dark small color="green darken-4" :href="`tel:+1${item.cellphone}`">
                          <v-icon dark>mdi-cellphone</v-icon>
                        </v-btn>
                        <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${item.email}`">
                          <v-icon dark>mdi-email</v-icon>
                        </v-btn>

                    </div>
                    <br />
                    <v-divider :key="item.capid + index"></v-divider>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>

      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->
  </div>
</template>

<script>
export default {
  name: 'CheckPilotListDetail',
  props: ['groupId','typeId','capId'],
  components: {
  },
  data() {
    return {
      isLoading: false,
      cpRecord: []
    }
  },
  mounted() {
    this.getData();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    getData() {

      this.isLoading = true;
      var tempCheckPilots = this.lookupCheckPilotList;
      const result = tempCheckPilots.filter(item => (item.capid == this.capId));
      this.cpRecord = result;
      this.isLoading = false;
    }
  }
}
</script>

<style>
  .listItem {
    height:30px;
  }

</style>
